var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_575_671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6632 27.121L11.6334 28.824C11.835 29.1827 12.1248 29.4644 12.465 29.6693C13.4396 28.4122 14.1178 27.4475 14.5 26.7752C14.8879 26.093 15.3645 25.0259 15.9301 23.5739C14.4059 23.37 13.2509 23.2681 12.4651 23.2681C11.7109 23.2681 10.5559 23.37 9 23.5739C9 23.9709 9.1008 24.3678 9.30241 24.7264L10.6632 27.121Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5349 29.6693C27.8752 29.4644 28.165 29.1827 28.3665 28.8241L28.7698 28.1199L30.6977 24.7264C30.8955 24.3756 30.9997 23.9783 31 23.5739C29.4351 23.37 28.2822 23.2681 27.5413 23.2681C26.745 23.2681 25.5921 23.37 24.0825 23.5739C24.6414 25.0338 25.1118 26.101 25.4938 26.7752C25.879 27.4555 26.5594 28.4201 27.5349 29.6693Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 16.4027C21.1277 15.0189 21.9047 13.9517 22.3312 13.2014C22.6747 12.5972 23.0528 11.6325 23.4652 10.3073C23.125 10.1024 22.7344 10 22.3312 10H17.6692C17.266 10 16.8755 10.1153 16.5352 10.3073C17.0599 11.8272 17.5052 12.9088 17.871 13.5522C18.2752 14.2633 18.9849 15.2134 20.0002 16.4027Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.07 23.5737H15.9303L12.4653 29.6691C12.8055 29.874 13.1961 29.9764 13.5993 29.9764H26.4011C26.8043 29.9764 27.1949 29.8612 27.5351 29.669L24.0701 23.5737H24.07Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.4027L16.535 10.3074C16.1947 10.5123 15.9049 10.7939 15.7033 11.1525L9.30241 22.4213C9.10451 22.7721 9.00026 23.1694 9 23.5737H15.9301L20 16.4027Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4971 16.7869L24.2966 11.1525C24.095 10.7939 23.8052 10.5123 23.465 10.3074L20 16.4027L24.0698 23.5738H30.9873C30.9873 23.1768 30.8865 22.7799 30.6849 22.4213L27.4971 16.7869Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_575_671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.92d55d2f837ce2c0b0dc6b09a3fb3d38.svg";
export { ForwardRef as ReactComponent };